import { render, staticRenderFns } from "./tutorialForm.vue?vue&type=template&id=3febd70c&scoped=true&"
import script from "./tutorialForm.vue?vue&type=script&lang=js&"
export * from "./tutorialForm.vue?vue&type=script&lang=js&"
import style0 from "./tutorialForm.vue?vue&type=style&index=0&id=3febd70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3febd70c",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QSelect,QBtn,QImg});
